import { useContext, useState, useEffect } from 'react';
import { useIntl } from 'gatsby-plugin-react-intl';
import { DateTime } from 'luxon';

import { CoreContext } from '../..';
import { FormatInterest } from '../../../../Core/CurrencyFormatter';
import Loader from '../../../../Core/Loader';

import {
  InterestTable,
  InterestTbody,
  InterestTr,
  InterestTd,
  Content,
  StyledP,
} from './styles';

const InterestsTableComponent = () => {
  const intl = useIntl();
  const { core } = useContext(CoreContext);
  const [loading, setLoading] = useState(true);
  let timeOut;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (core.baseInterestRate) {
        setLoading(false);
      } else {
        timeOut = window.setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    }
    return () => {
      clearTimeout(timeOut);
    };
  }, [core.rates.baseInterestRate]);

  const totalRates = core.rates.promoInterestRate
    ? core.rates.promoInterestRate
    : core.rates.baseInterestRate;

  return (
    <Content>
      {loading ? (
        <Loader />
      ) : (
        <>
          <StyledP>
            {`${intl.formatMessage({ id: 'rateAsOf' })} ${DateTime.now().setZone('America/Toronto').setLocale(intl.locale).toLocaleString(DateTime.DATE_FULL)}`}
          </StyledP>
          <InterestTable>
            <InterestTbody>
              <InterestTr>
                <InterestTd>
                  <b>{intl.formatMessage({ id: 'balance' })}</b>
                </InterestTd>
                <InterestTd>
                  <b>{intl.formatMessage({ id: 'interestRate' })}</b>
                </InterestTd>
              </InterestTr>
              <InterestTr>
                <InterestTd>
                  {intl.formatMessage({ id: 'savingBalance' })}
                </InterestTd>
                {core.rates.baseInterestRate && (
                  <InterestTd>{`${FormatInterest(totalRates, intl.locale)}`}</InterestTd>
                )}
                {!core.rates.baseInterestRate && (
                  <InterestTd>
                    {intl.formatMessage({ id: 'notAvailable' })}
                  </InterestTd>
                )}
              </InterestTr>
              <InterestTr>
                <InterestTd>
                  {intl.formatMessage({ id: 'spendingBalance' })}
                </InterestTd>
                <InterestTd>{`${FormatInterest(0, intl.locale)}`}</InterestTd>
              </InterestTr>
            </InterestTbody>
          </InterestTable>
        </>
      )}
    </Content>
  );
};

export default InterestsTableComponent;
